import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// images
import americanCenturyInvestments from './images/american-century-investments-logo.webp';
import americanGroupCapitalFunds from './images/american-group-capital-funds-logo.webp';
import fidelityInvestments from './images/fidelity-investments-logo.webp';
import franklinTempleton from './images/franklin-templeton-logo.webp';
import mfs from './images/mfs-logo.webp';
import pimco from './images/pimco-logo.webp';
import russellInvestments from './images/russell-investments-group-logo.webp';
// styles
import { ColStyled } from './styles';

export const ITEMS = [
  {
    id: 'american-century-investments-link',
    imageSrc: americanCenturyInvestments,
    imageAltText: 'American Century Investments logo',
    linkUrl: 'https://corporate.americancentury.com/en.html',
    ariaLabel: 'American Century Investments',
  },
  {
    id: 'capital-group-american-funds-link',
    imageSrc: americanGroupCapitalFunds,
    imageAltText: 'Capital Group American Funds logo',
    linkUrl: 'https://www.capitalgroup.com/individual/',
    ariaLabel: 'Capital Group American Funds',
  },
  {
    id: 'fidelity-investments-link',
    imageSrc: fidelityInvestments,
    imageAltText: 'Fidelity Investments logo',
    linkUrl: 'https://www.fidelity.com/',
    ariaLabel: 'Fidelity Investments',
  },
  {
    id: 'franklin-templeton-link',
    imageSrc: franklinTempleton,
    imageAltText: 'Franklin templeton logo',
    linkUrl: 'https://www.franklintempleton.com/',
    ariaLabel: 'Franklin Templeton',
  },
  {
    id: 'russell-investments-link',
    imageSrc: russellInvestments,
    imageAltText: 'Russell Investments logo',
    linkUrl: 'https://russellinvestments.com/us',
    ariaLabel: 'Russell Investments',
  },
  {
    id: 'pimco-link',
    imageSrc: pimco,
    imageAltText: 'PIMCO Investment Management logo',
    linkUrl: 'https://www.pimco.com/en-us/?showSplash=1',
    ariaLabel: 'PIMCO Investment Management',
  },
  {
    id: 'mfs-link',
    imageSrc: mfs,
    imageAltText: 'MFS Investment Management logo',
    linkUrl: 'https://www.mfs.com/en-us/individual-investor.html',
    ariaLabel: 'MFS Investment Management',
  },
];

export default () => (
  <SectionContainer
    id='mutual-funds-partners-header'
    disableBottomPadding>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'
          align='center'
          nextElement='typography'>
          Mutual Fund Partners
        </Typography>
        <Typography nextElement='graphic'>
          At Northwestern Mutual, we believe in working for you and with you to help meet your needs and accomplish your goals. We will help with your investment needs and continue to provide service and support&#8212;as long as you need it. Because there are thousands of mutual funds available to investors, we focus on a select group of fund families that offer a broad spectrum of mutual funds.
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      {(
        ITEMS.map((item) => (
          <ColStyled
            xsmall={6}
            medium={4}
            xlarge={3}
            key={`${item.id}-col`}>
            <Link
              id={item.id}
              variant='primary'
              linkUrl={item.linkUrl}
              ariaLabel={item.ariaLabel}
              isOutgoingLink>
              <Picture
                src={item.imageSrc}
                altText={item.imageAltText} />
            </Link>
          </ColStyled>
        ),
        )
      )}
    </Row>
  </SectionContainer>
);
